
import { SupplierFormFields } from './SupplierFormFields';
import { SupplierFormActions } from './SupplierFormActions';
import { useSupplierForm } from '@/hooks/useSupplierForm';

interface Supplier {
  id: string;
  name_ar: string;
  name_en: string;
  employee_name_ar: string;
  employee_name_en: string;
  mobile: string;
  country: string;
  departments: string;
  email: string;
  access_permission: boolean;
  created_at: string;
  updated_at: string;
}

interface SupplierFormProps {
  supplier: Supplier | null;
  onClose: () => void;
}

export function SupplierForm({ supplier, onClose }: SupplierFormProps) {
  const { formData, loading, handleInputChange, handleSubmit } = useSupplierForm({
    supplier,
    onClose,
  });

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <SupplierFormFields formData={formData} onInputChange={handleInputChange} />
      <SupplierFormActions supplier={supplier} loading={loading} onClose={onClose} />
    </form>
  );
}
